import React from 'react';
import { useTranslation } from 'react-i18next';
import Divider from '@material-ui/core/Divider';
import './stars.scss';
import '../styles/intro.css';

const Intro = () => {
	const { t } = useTranslation();

	return (
		<div id="home" className="intro route bg-image background">
			<div id="stars" />
			<div id="stars2" />
			<div id="stars3" />

			<div className="intro-content display-table">
				<div className="table-cell">
					<div className="container-modern">
						<div className="hero-eyebrow">{t('hero.eyebrow')}</div>
						<h1 className="hero-headline">
							{t('hero.headline')}<br />
							<span className="hero-highlight">{t('hero.headlineHighlight')}</span>
						</h1>
						<div>
							<Divider />
						</div>
						<p className="hero-subheadline">
							{t('hero.subheadline')}
						</p>
						<div className="hero-ctas">
							<a
								className="btn-modern btn-hero-primary js-scroll"
								href="#discover"
								role="button"
							>
								{t('hero.ctaPrimary')}
								<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
									<path d="M12 5v14M5 12l7 7 7-7"/>
								</svg>
							</a>
							<a
								className="btn-modern btn-hero-secondary js-scroll"
								href="#contact"
								role="button"
							>
								{t('hero.ctaSecondary')}
							</a>
						</div>
						<div className="hero-trust-bar">
							<span className="hero-trust-item">
								<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
								{t('hero.trust1')}
							</span>
							<span className="hero-trust-item">
								<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
								{t('hero.trust2')}
							</span>
							<span className="hero-trust-item">
								<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
								{t('hero.trust3')}
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Intro;
